import gql from 'graphql-tag';

export const PATIENT_QUERY = gql`
  query patientData {
    patient {
      id
      patientMembership {
        id
        createdAt
        employer
        membershipRules {
          code
          id
          discountId
        }
      }
    }
  }
`;

export const MY_JOURNEY_QUERY = gql`
  query myJourney {
    journeyType

    appointments: journeyAppointments {
      id
      startTime
      endTime
      timeZone

      appointmentType {
        id
      }
    }

    results {
      afc: follicleCounts {
        date
      }
      labs {
        date
      }
    }

    patientTodos {
      id
      todoId
      title: name
      linkUrl
      buttonText
      description
      completed
    }

    cyclePlan {
      id
      finished
      expectedDeliveryDate
      deliveryDate
    }
  }
`;
